import { messageTexts, successMessage } from '../utils/sweet-alert-options';
import store from '../store/store';

export default {
    methods: {
        async toPreviousStep(previousPageRouteName) {
            await this.$router.push(this.buildRoute(previousPageRouteName));
        },
        async updateDue() {
            try {
                await this.updateCurrentDue(await this.prepareRequest());
            } catch ({ response }) {
                this.nextStepIsLoading = false;
                this.saveIsLoading = false;
            }
        },
        async saveDue() {
            this.saveIsLoading = true;
            await this.updateDue();

            this.$swal({ title: messageTexts.dueDraftSave, ...successMessage });
            this.saveIsLoading = false;
        },
        async saveAndMoveForward(nextPageRouteName) {
            this.nextStepIsLoading = true;
            await this.updateDue();

            await this.$router.push(this.buildRoute(nextPageRouteName));
            this.nextStepIsLoading = false;
        },
        buildRoute(routeName) {
            let routeObject = { name: routeName };
            if (store.getters.isEdit) {
                routeObject.params = { id: store.getters.updateDueId }
            }

            return routeObject;
        }
    }
}